// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dDate from "../Data.Date/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dCalendar$dTypes$dRestaurantLocalDay from "../Restaumatic.Calendar.Types.RestaurantLocalDay/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $PreorderSettings = (tag, _1) => ({tag, _1});
const SameDayIsSymbol = {reflectSymbol: () => "SameDay"};
const maxDaysIsSymbol = {reflectSymbol: () => "maxDays"};
const RelativeDateIsSymbol = {reflectSymbol: () => "RelativeDate"};
const fromIsSymbol = {reflectSymbol: () => "from"};
const toIsSymbol = {reflectSymbol: () => "to"};
const AbsoluteDateIsSymbol = {reflectSymbol: () => "AbsoluteDate"};
const encodeWithOptionsOther = {encodeWithOptions: v => Restaumatic$dCalendar$dTypes$dRestaurantLocalDay.encodeRestaurantLocalDay.encode};
const decodeWithOptionsOther = {decodeWithOptions: v => Restaumatic$dCalendar$dTypes$dRestaurantLocalDay.decodeRestaurantLocalDay.decode};
const SameDay = /* #__PURE__ */ $PreorderSettings("SameDay");
const RelativeDate = value0 => $PreorderSettings("RelativeDate", value0);
const AbsoluteDate = value0 => $PreorderSettings("AbsoluteDate", value0);
const toFillFormTypePreorderSet = {fillFormDataType: v => "unknown"};
const eqPreorderSettings = {
  eq: x => y => {
    if (x.tag === "SameDay") { return y.tag === "SameDay"; }
    if (x.tag === "RelativeDate") {
      if (y.tag === "RelativeDate") { return x._1.maxDays === y._1.maxDays; }
      return false;
    }
    if (x.tag === "AbsoluteDate") {
      if (y.tag === "AbsoluteDate") { return Data$dDate.eqDate.eq(x._1.from)(y._1.from) && Data$dDate.eqDate.eq(x._1.to)(y._1.to); }
      return false;
    }
    return false;
  }
};
const genericPreorderSettings = {
  to: x => {
    if (x.tag === "Inl") { return SameDay; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return $PreorderSettings("RelativeDate", x._1._1); }
      if (x._1.tag === "Inr") { return $PreorderSettings("AbsoluteDate", x._1._1); }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "SameDay") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "RelativeDate") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)); }
    if (x.tag === "AbsoluteDate") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1)); }
    $runtime.fail();
  }
};
const showPreorderSettings = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(SameDayIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => ["{ maxDays: " + Data$dShow.showIntImpl(v.maxDays) + " }"]})(RelativeDateIsSymbol);
    const $2 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        "{ from: " + Restaumatic$dCalendar$dTypes$dRestaurantLocalDay.showRestaurantLocalDay.show(v.from) + ", to: " + Restaumatic$dCalendar$dTypes$dRestaurantLocalDay.showRestaurantLocalDay.show(v.to) + " " + "}"
      ]
    })(AbsoluteDateIsSymbol);
    return x => {
      const $3 = genericPreorderSettings.from(x);
      if ($3.tag === "Inl") { return $0["genericShow'"]($3._1); }
      if ($3.tag === "Inr") {
        if ($3._1.tag === "Inl") { return $1["genericShow'"]($3._1._1); }
        if ($3._1.tag === "Inr") { return $2["genericShow'"]($3._1._1); }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodePreorderSettings = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(SameDayIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(RelativeDateIsSymbol)({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons(maxDaysIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumConstruct(AbsoluteDateIsSymbol)({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons(fromIsSymbol)(Restaumatic$dCalendar$dTypes$dRestaurantLocalDay.unscrambleDecodeRestaurantLocalDay)(Unscramble.decodeRecordCons(toIsSymbol)(Restaumatic$dCalendar$dTypes$dRestaurantLocalDay.unscrambleDecodeRestaurantLocalDay)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
    }))))(Unscramble$dGeneric.defaultOptions);
    return x => genericPreorderSettings.to($0(x));
  })()
};
const encodePreorderSettings = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericPreorderSettings)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(SameDayIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor(RelativeDateIsSymbol)((() => {
      const $1 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(maxDaysIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $1.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor(AbsoluteDateIsSymbol)((() => {
      const $2 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(toIsSymbol)(encodeWithOptionsOther))(fromIsSymbol)(encodeWithOptionsOther);
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $2.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    return {
      encodeOpts: v => v1 => {
        if (v1.tag === "Inl") { return $0.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        if (v1.tag === "Inr") {
          if (v1._1.tag === "Inl") { return $1.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1); }
          if (v1._1.tag === "Inr") { return $2.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1); }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const decodePreorderSettings = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericPreorderSettings)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(SameDayIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(RelativeDateIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(maxDaysIsSymbol)({
    decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(AbsoluteDateIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(toIsSymbol)(decodeWithOptionsOther)())(fromIsSymbol)(decodeWithOptionsOther)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))))
};
export {
  $PreorderSettings,
  AbsoluteDate,
  AbsoluteDateIsSymbol,
  RelativeDate,
  RelativeDateIsSymbol,
  SameDay,
  SameDayIsSymbol,
  decodePreorderSettings,
  decodeWithOptionsOther,
  encodePreorderSettings,
  encodeWithOptionsOther,
  eqPreorderSettings,
  fromIsSymbol,
  genericPreorderSettings,
  maxDaysIsSymbol,
  showPreorderSettings,
  toFillFormTypePreorderSet,
  toIsSymbol,
  unscrambleDecodePreorderSettings
};
